import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Slider } from '@/components/ui/slider'
import type { Question } from '@/types/form'

interface QuestionSettingsProps {
  question: Question
  onChange: (patch: Partial<Question['settings']>) => void
}

export function RatingSettings({ question, onChange }: QuestionSettingsProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label>評分級距：{question.settings.steps ?? 5}</Label>
        <Slider
          value={[Number(question.settings.steps ?? 5)]}
          min={1}
          max={10}
          step={1}
          onValueChange={([steps]) => onChange({ steps })}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label>樣式</Label>
        <Select
          value={question.settings.style ?? 'number'}
          onValueChange={(style) => onChange({ style: style as Question['settings']['style'] })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="number">數字</SelectItem>
            <SelectItem value="stars">星星</SelectItem>
            <SelectItem value="hearts">愛心</SelectItem>
            <SelectItem value="emoji">表情符號</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Input
        value={question.settings.startLabel ?? ''}
        placeholder="起始標籤"
        onChange={(event) => onChange({ startLabel: event.target.value })}
      />
      <Input
        value={question.settings.endLabel ?? ''}
        placeholder="結束標籤"
        onChange={(event) => onChange({ endLabel: event.target.value })}
      />
    </div>
  )
}
